import { render } from "./CardLabel.vue?vue&type=template&id=44df08e4&scoped=true"
import script from "./CardLabel.vue?vue&type=script&lang=js"
export * from "./CardLabel.vue?vue&type=script&lang=js"

import "./CardLabel.vue?vue&type=style&index=0&id=44df08e4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-44df08e4"

export default script